import { Actions, UserInformationActionTypes } from '@core/store/actions';
import { UserInformation } from '@model';

export interface State {
  loaded: boolean;
  loading: boolean;
  userInformations: UserInformation[];
}

export const initialState: State = {
  loaded: false,
  loading: false,
  userInformations: []
};

export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case UserInformationActionTypes.LoadUserInformation:
      return { ...state, loaded: false, loading: true };

    case UserInformationActionTypes.LoadUserInformationSuccess:
      return {
        ...state,
        userInformations: action.payload,
        loaded: true,
        loading: false
      };
    case UserInformationActionTypes.LoadUserInformationFail:
      return { ...state, loaded: false, loading: false };

    case UserInformationActionTypes.InformationSetAsRead:
        return { ...state, loaded: false, loading: true };
  
      case UserInformationActionTypes.InformationSetAsReadSuccess:
        if (state.userInformations.length === 0) {
          return { ...state, loaded: true, loading: false, userInformations: [action.payload] };
        }

        let updatedUserInformationList = state.userInformations.map(x => {
          if (x.id === action.payload.id) {
            return action.payload;
          }
          return x;
        });

        if (state.userInformations.some(y => y.id !== action.payload.id)) {
          updatedUserInformationList.push(action.payload);
        }

        return { ...state, loaded: true, loading: false, userInformations: updatedUserInformationList };
  
      case UserInformationActionTypes.InformationSetAsReadFail:
        return { ...state, loaded: false, loading: false };
  }
  return state;
}

export const _getUserInformations = (state: State) => state.userInformations;
export const _getUserInformationsLoaded = (state: State) => state.loaded;
export const _getUserInformationsLoading = (state: State) => state.loading;
